import React, { useEffect, useState } from 'react'
import styled from "styled-components"
import { Alert, AlertDescription, AlertIcon  } from '@rockr/rock-ui'
import { AlertProps, CloseButton } from "@chakra-ui/core"
import { FadeInRight } from '../Animation'

type Props = AlertProps & {
  message: string
  show: boolean
  timeout?: number
}

const AlertDiv = styled.div`
position: fixed;
bottom: 10px;
width: 50%;
z-index: 9999;
right: 10px;
`

export const Notification: React.FC<Props> = (props) => {
  const {
    message,
    show,
    status,
    timeout
  } = props

  const [hidde, setHidde] = useState(true)

  useEffect(() => {
    setHidde(!show)
    setTimeout(() => setHidde(true), timeout || 7000)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  if(show && !hidde) {
    return (
      <AlertDiv>
        <FadeInRight>
          <Alert status={status}>
          <AlertIcon />
              <AlertDescription>{message}</AlertDescription>
            <CloseButton onClick={() => setHidde(true)} position="absolute" right="8px" top="8px" />
          </Alert>
        </FadeInRight>
      </AlertDiv>
    )
  }
  return null
}